import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import ChangeEmailPage from '@/settings/pages/change-email';

export const Route = createFileRoute('/settings/user-profile/change-email')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: ChangeEmailRoute,
  staticData: {
    headerSection: null
  }
});

function ChangeEmailRoute() {
  return <ChangeEmailPage/>;
}
